import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	menuLabel: {
		id: 'inactive-projects-directory-base.projects-table.body.cells.trash.menu-label',
		defaultMessage: 'More',
		description: 'Dropdown button label for actions button in trashed projects table',
	},
	actionRestoreProject: {
		id: 'inactive-projects-directory-base.projects-table.body.cells.trash.action-restore-project',
		defaultMessage: 'Restore',
		description: 'Menu item text for restore action in trashed projects table',
	},
	actionPermanentDeleteProject: {
		id: 'inactive-projects-directory-base.projects-table.body.cells.trash.action-permanent-delete-project',
		defaultMessage: 'Delete permanently',
		description: 'Menu item text for permanent delete action in trashed projects table',
	},
});
